import { CRUD } from "@/shared/components";
import {
  DocumentsListQuery,
  DocumentShowQuery,
  DeleteDocumentsMutation,
  RestoreDocumentsMutation,
} from "@/admin/entities/documents";
import {
  useDocumentsManagement,
  type DocumentRow,
  DocumentsSchemas,
} from "../model";
import { DocumentShow } from "..";

/**
 * UI компонент для управления документами
 * Чистый презентационный компонент, использует логику из model слоя
 * GraphQL операции импортирует из documents entity
 */
export function Documents() {
  const { columns, mobileColumns, mapColumns, getTableData, texts } =
    useDocumentsManagement();

  return (
    <CRUD<DocumentRow>
      listQuery={DocumentsListQuery}
      getTableData={getTableData}
      mapColumns={mapColumns}
      columns={columns}
      filterSchema={DocumentsSchemas.filterSchema}
      createSchema={DocumentsSchemas.createSchema}
      editSchema={{
        ...DocumentsSchemas.editSchema,
        details: {
          ...DocumentsSchemas.editSchema.details,
          showComponent: DocumentShow,
        },
      }}
      editQuery={DocumentShowQuery}
      deleteMutation={DeleteDocumentsMutation}
      restoreMutation={RestoreDocumentsMutation}
      texts={texts}
      persistFilters
      useMobileView
      mobileColumns={mobileColumns}
    />
  );
}
